import { styled, Toggle as ToggleRoot, Theme } from '@withjoy/joykit';

interface ToggleProps {
  bgColor?: keyof Theme['colors'];
}

export const Toggle = styled(ToggleRoot)<ToggleProps>`
  input:checked ~ .joykit-choice-indicator {
    background-color: ${({ theme, bgColor }) => theme.colors[bgColor || 'mono14']};
  }
  input ~ .joykit-choice-indicator {
    width: 56px;
  }
  input:checked ~ .joykit-choice-indicator::before {
    transform: translateY(-50%) translateZ(0.1px) translateX(27px) !important;
  }
`;
